// Selection.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Selection(){

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const { handleSearch } = useContext(searchContext);
    const { handleNote } = useContext(noteContext);      
    const { handleCopy } = useContext(homeContext);  

    const dispatch = useDispatch(); // dispatch(
    const bookListItemSelected = useSelector((state) => state.book.bookListItemSelected);
    const viewArea = useSelector((state) => state.home.viewArea);
    const credential = useSelector((state) => state.signIn.credential);
    const userListItem = useSelector((state) => state.home.userListItem);

    const [open4, setOpen4] = useState(false);

    const handlePopoverOpen4 = (e) => {
        dispatch(setBook4Accordion1(0));
        dispatch(setNoteBookmarkListItemToBeChanged(null));
        setOpen4(true);
        dispatch(setTab4AddChange(1));
    }

    const handlePopoverOpen2 = async (e) => {
        getHistoryList('Selection');
        dispatch(setOpen2(true));
        dispatch(setHistoryListItemSelected(0));
    }

    return (

        <div>          

            <Box
                sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' }, // column on xs, row on md+
                gap: 1, // space between selects
                width: '100%',
                }}      
            >
                
                <Grid xs={12}>
                    <Book />
                </Grid>
                
                <div style={{ display: bookListItemSelected > 0 ? 'block' : 'none' }}>
                    <Grid xs={12}>
                        <Chapter />
                    </Grid>
                </div>                           

                <Grid xs={12}>

                    <Box
                    sx={{
                        display: "flex", // Use flexbox
                        gap: 1,          // Set the gap between ButtonGroups (e.g., 2 is equal to 16px)
                    }}
                    >

                        <ButtonGroup 
                            variant="outlined" 
                            size='small'
                            sx={{
                            height: 35,
                            border: '1px solid',
                            borderColor: 'primary.main',
                            '& .MuiButtonGroup-grouped': { border: 'none' },
                            '& .MuiButtonGroup-grouped:not(:last-of-type)': {
                                borderRight: '1px solid',
                            },            
                            }}          
                        >

                            <Button
                            sx={{
                                borderRadius: 0,
                                //bgcolor: 'primary.main',
                                '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                            }}
                            >
                            <HistoryIcon onClick={handlePopoverOpen2}/>
                            </Button> 

                            <Button
                            sx={{
                                borderRadius: 0,
                                //bgcolor: 'primary.main',
                                '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                            }}
                            >
                            <NoteAddIcon onClick={handlePopoverOpen4}/>
                            </Button> 

                            {/* <Button 
                                variant="outlined"
                                sx={{
                                    color: 'primary.main',
                                    backgroundColor: 'inherit',                          
                                    border: '1px solid',
                                    borderColor: 'primary.main',              
                                    borderRadius: 0,
                                    '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                                }}                                 
                            >
                                <LocalOfferIcon onClick={() => handleCopy()}/>
                            </Button> */}

                            <Button 
                                variant="outlined"
                                sx={{
                                    color: 'primary.main',
                                    backgroundColor: 'inherit',                          
                                    border: '1px solid',
                                    borderColor: 'primary.main',              
                                    borderRadius: 0,
                                    '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                                }}                                 
                            >
                                <FileCopyIcon onClick={() => handleCopy()}/>
                            </Button>

                        </ButtonGroup>

                        <History />
                        <AddChangeNote open4={open4} setOpen4={setOpen4}/>

                        <ButtonGroup 
                            variant="outlined" 
                            size='small'
                            sx={{
                            height: 35,
                            border: '1px solid',
                            borderColor: 'primary.main',
                            '& .MuiButtonGroup-grouped': { border: 'none' },
                            '& .MuiButtonGroup-grouped:not(:last-of-type)': {
                                borderRight: '1px solid',
                            },            
                            }}          
                        >

                        <Button 
                            variant="outlined"
                            sx={{
                                color: viewArea === 'VerseSearch' ? 'white' : 'primary.main',
                                backgroundColor: viewArea === 'VerseSearch' ? 'primary.main' : 'inherit',
                                border: '1px solid',
                                borderColor: 'primary.main',              
                                borderRadius: 0,
                                '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                            }}                                         
                            >
                                <SearchIcon onClick={() => handleSearch(true)}/>
                            </Button>

                            <Button 
                            variant="outlined"
                            sx={{
                                color: viewArea === 'Note' ? 'white' : 'primary.main',
                                backgroundColor: viewArea === 'Note' ? 'primary.main' : 'inherit',                          
                                border: '1px solid',
                                borderColor: 'primary.main',              
                                borderRadius: 0,
                                '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                            }}                                 
                            >
                                <DescriptionIcon onClick={() => handleNote(true)}/>
                            </Button>    

                        </ButtonGroup>
                        {/* {viewArea} */}
                    </Box>

                </Grid>

            </Box>

        </div>

    )

}